import React from "react";
import { Helmet } from "react-helmet";
import "../styles/subpages.css";

const Impresszum = () => {
  return (
    <section id="impresszum" className="subpage-section subpage">
      <Helmet>
        <title>Impresszum | Autókölcsönző Szolnok</title>
        <meta
          name="description"
          content="A Autókölcsönző Szolnok weboldal üzemeltetőjének jogi adatai és kötelező tájékoztatása az Eker. tv. 4. § alapján."
        />
        <link
          rel="canonical"
          href="https://autokolcsonzoszolnok.hu/impresszum"
        />

        {/* Open Graph */}
        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Impresszum | Autókölcsönző Szolnok"
        />
        <meta
          property="og:description"
          content="Az Autókölcsönző Szolnok weboldal üzemeltetőjének jogi és kapcsolati adatai."
        />
        <meta
          property="og:url"
          content="https://autokolcsonzoszolnok.hu/impresszum"
        />
        <meta property="og:image" content="/og.png" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Impresszum | Autókölcsönző Szolnok"
        />
        <meta
          name="twitter:description"
          content="Üzemeltetői és jogi információk az Autókölcsönző Szolnok weboldaláról."
        />
        <meta name="twitter:image" content="/og.png" />
      </Helmet>

      <div className="container text-center d-flex flex-column align-items-center">
        <header className="subpage-header pt-5 mt-3">
          <h1>Impresszum</h1>
          <div className="divider mx-auto">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <p className="subpage-intro">
            Jelen impresszum az autokolcsonzoszolnok.hu weboldal üzemeltetőjének
            jogi adatait, valamint az Eker. tv. 4. § szerinti kötelező
            tájékoztatást tartalmazza.
          </p>
        </header>

        <div className="subpage-card text-center">
          <h3>1. Szolgáltató adatai</h3>
          <p>
            <strong>Üzemeltető:</strong> Autókölcsönző Szolnok <br />
            <strong>Székhely:</strong> 5000 Szolnok, Kaán Károly út 11. <br />
            <strong>E-mail:</strong>{" "}
            <a href="mailto:info@autokolcsonzoszolnok.hu">
              info@autokolcsonzoszolnok.hu
            </a>{" "}
            <br />
            <strong>Telefon:</strong>{" "}
            <a href="tel:+36706276599">+36 70 627 65 99</a>
          </p>

          <h3>2. Tárhelyszolgáltató</h3>
          <p>
            <strong>Szolgáltató:</strong> Amazon Web Services (AWS) <br />
            <strong>Székhely:</strong> Seattle, WA, USA <br />
            <strong>Weboldal:</strong>{" "}
            <a href="https://aws.amazon.com" target="_blank" rel="noreferrer">
              https://aws.amazon.com
            </a>
          </p>

          <h3>3. Felelősség kizárása</h3>
          <p>
            A weboldalon található információk tájékoztató jellegűek.
            Üzemeltetőként mindent megteszünk a pontos és naprakész tartalomért,
            azonban az esetleges hibákért, elírásokért, vagy téves adatokért
            felelősséget nem vállalunk.
          </p>

          <h3>4. Szerzői jogok</h3>
          <p>
            A weboldal teljes tartalma – ideértve a szövegeket, képeket,
            grafikákat, logókat – az Autókölcsönző Szolnok tulajdona. A tartalom
            bármilyen másolása, módosítása vagy felhasználása kizárólag az
            üzemeltető előzetes írásos engedélyével lehetséges.
          </p>

          <h3>5. Jogviták</h3>
          <p>
            A weboldal használatából eredő esetleges jogviták esetén a felek a
            Szolnoki Járásbíróság illetékességét kötik ki.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Impresszum;
